import { useState } from "react";
import { useTranslation } from "react-i18next";
import ConsentModal from "../components/ConsentModal";

const ApplicationFormSection = () => {
  const [checked, setChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [nameError, setNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [checkboxError, setCheckboxError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = () => {
    let hasError = false;

    if (!name.trim()) {
      setNameError(true);
      hasError = true;
    } else {
      setNameError(false);
    }

    if (!phone.trim()) {
      setPhoneError(true);
      hasError = true;
    } else {
      setPhoneError(false);
    }

    if (!checked) {
      setCheckboxError(true);
      hasError = true;
    } else {
      setCheckboxError(false);
    }

    if (!hasError && checked) {
      // Form submit logic here
      console.log("Form submitted:", { name, phone });
      
      // Показать сообщение об успехе
      setIsSuccess(true);
      
      // Очистить форму
      setName("");
      setPhone("");
      setChecked(false);
      
      // Скрыть сообщение через 5 секунд
      setTimeout(() => {
        setIsSuccess(false);
      }, 5000);
    }
  };
  return (
    <section id="contacts" className="w-full ">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 lg:h-[810px] bg-white">
          <div className="relative w-full h-full px-5 pt-15 lg:pl-[60px] lg:py-[150px] lg:pr-[110px] border border-red-900">
            <h2 className="text-[30px] md:text-[36px] font-normal font-['Forum'] uppercase leading-[26px] md:leading-[36px] text-red-900 text-center lg:text-left">
              {t("form.title")}
            </h2>
            <p className="text-[20px] font-light font-['Inter'] leading-[20px] text-red-900 text-center lg:text-left">
              {t("form.subtitle")}
            </p>
            <div className="relative mt-[70px]">
              <input
                type="text"
                placeholder={t("form.namePlaceholder")}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (nameError) setNameError(false);
                }}
                className={`
    w-full
    bg-transparent
    border-b
    ${nameError ? "border-red-900" : "border-gray-400"}
    hover:border-gray-400
    focus:border-gray-400
    outline-none
    focus:outline-none
    focus:ring-0
    transition-colors
    duration-150
    px-0
    py-2
    pl-[30px]
    text-[16px]
    font-['Inter']
    font-normal
  `}
              />
              {nameError && (
                <div className=" ">
                  <span className="text-red-900 text-[9px] font-['Inter'] font-light leading-[11px] tracking-[-0.05em]">
                    {t("form.fieldRequired")}
                  </span>
                </div>
              )}
            </div>
            <div className="relative mt-[60px]">
              <input
                type="tel"
                placeholder={t("form.phonePlaceholder")}
                pattern="\+7 \d{3} \d{3} \d{2} \d{2}"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  if (phoneError) setPhoneError(false);
                }}
                className={`
    w-full
    bg-transparent
    border-b
    ${phoneError ? "border-red-900" : "border-gray-400"}
    hover:border-gray-400
    focus:border-gray-400
    outline-none
    focus:outline-none
    focus:ring-0
    transition-colors
    duration-150
    px-0 py-2
    pl-[30px]
    text-[16px]
    font-['Inter']
    font-normal
  `}
              />
              {phoneError && (
                <div className=" ">
                  <span className="text-red-900 text-[9px] font-['Inter'] font-light leading-[11px] tracking-[-0.05em]">
                    {t("form.fieldRequired")}
                  </span>
                </div>
              )}
            </div>
            <div className="relative mt-[20px]">
              <label className="flex items-center space-x-2 cursor-pointer relative select-none">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => {
                    setChecked(!checked);
                    if (checkboxError) setCheckboxError(false);
                  }}
                  className="
            w-[20px] h-[20px] 
            min-w-[20px]
            flex-shrink-0
            bg-white 
            border-2 border-red-900 
            rounded-[3px] 
            appearance-none
            focus:ring-0
          "
                />
                {/* SVG галочка */}
                {checked && (
                  <svg
                    className="absolute left-[5px] top-[6px] w-[10px] h-[7.5px]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 12 10"
                    fill="none"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <path
                      d="M0.650757 5.15527L4.15076 8.15527L10.6508 0.655273"
                      stroke="#881F1F"
                      strokeWidth="2"
                    />
                  </svg>
                )}

                <span className="text-gray-700 text-[11px] font-['Inter'] font-normal leading-[11px]">
                  {t("form.consentTextPrefix")}{" "}
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    className="text-red-900 underline hover:text-red-700 cursor-pointer"
                  >
                    {t("form.consentLink")}
                  </button>
                </span>
              </label>
              {checkboxError && (
                <div className="mt-[10px] flex items-start">
                  {/* Speech bubble */}
                  <div className="relative bg-red-900 rounded-sm  flex items-center p-[5px]">
                    {/* Arrow pointing up */}
                    <div className="absolute -top-[6px] left-[9px] w-0 h-0 border-b-[6px] border-b-red-900 border-r-[6px] border-r-transparent border-l-[6px] border-l-transparent"></div>
                    <span className="relative z-10 text-[#FCFCFC] text-[9px] font-['Inter'] font-light leading-[11px] tracking-[-0.05em] whitespace-nowrap">
                      {t("form.fieldRequired")}
                    </span>
                  </div>
                </div>
              )}
            </div>

            <button
              onClick={handleSubmit}
              className="mt-8 mb-10 h-[80px] bg-red-900 lg:mt-8 flex items-center justify-center text-[16px] font-['Inter'] font-medium leading-[50px] text-white w-full cursor-pointer hover:opacity-90 transition-opacity"
            >
              {t("form.submit")}
            </button>

            {isSuccess && (
              <div className="absolute top-0 left-0 right-0 bg-green-600 text-white px-4 py-3 rounded-sm flex items-center justify-center">
                <span className="text-[14px] font-['Inter'] font-medium">
                  {t("form.successMessage")}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="lg:w-1/2 h-[810px] bg-[url(/application-form.png)] bg-no-repeat bg-cover bg-center"></div>
      </div>

      <ConsentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAccept={() => {
          setChecked(true);
          setIsModalOpen(false);
        }}
        onReject={() => {
          setChecked(false);
          setIsModalOpen(false);
        }}
      />
    </section>
  );
};

export default ApplicationFormSection;
